'use strict';

angular.module('amexReconciliationApp')
  .service('TpdModel', function TpdModel($rootScope,
                                         ModelFactory,
                                         TpdRepository) {

    var tpdModel = ModelFactory.create('TpdModel', ['thirdPartyData', 'loading']);
    tpdModel.loading(false);

    tpdModel.getTpd = function (transactions, currentTpdBillingCycle, showUnlinkedOnly) {
      tpdModel.loading(true);
      TpdRepository.findByTransactionIdAndBillingCycle(currentTpdBillingCycle, transactions[0], showUnlinkedOnly).then(function(thirdPartyData) {
        tpdModel.thirdPartyData(thirdPartyData);
        tpdModel.loading(false);
      });
    };

    return tpdModel;

  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/models/TpdModel.js
// module id = 587
// module chunks = 0